import config from '@/config'

const MOTOR_TRACKER_URL = config.motorTrackerUrl

export { MOTOR_TRACKER_URL }
